import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import { UserSession } from '../types/commons';
import { del, post } from '../api/requester';

import { CreateUserResult, USERS_QUERY_KEY } from './user-queries';

const api = {
  create: (value: UserSession) => post('/session', { skipJsonParsing: true, body: { user: value } }),
  getCookie: () => post('/session', { headersOnly: true }),
  del: () => del('/session'),
};

export const useCreateSession = (
  options?: Omit<UseMutationOptions<CreateUserResult, Error, UserSession>, 'mutationFn'>,
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...otherOptions } = options || {};
  return useMutation<CreateUserResult, Error, UserSession>({
    mutationFn: async (session: UserSession) => {
      const result = await api.create(session);
      const user = await result.json();
      const token = result.headers.get('authorization');
      return { user, token };
    },
    onSuccess: async (response, variables, context) => {
      queryClient.setQueryData(USERS_QUERY_KEY, response.user);
      if (onSuccess) await onSuccess(response, variables, context);
    },
    ...otherOptions,
  });
};
